import { styled } from '../../theme';
import { BulletSection } from '../BulletSection';

export const CampaignBulletSection = styled(BulletSection).attrs((props) => ({
	...props,
	noIndent: true,
}))`
	background-color: ${({ theme }) => theme.color.lightOrange.base};
	padding-top: ${({ theme }) => theme.space.sm}px;
`;
